import React, { useCallback, useEffect, useState } from 'react';
import VendorActivityManagementDialog from './components/VendorActivityManagementDialog';
import { ButtonBase } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Tables } from '../../../../../Components';
import { GetVendorActivities } from '../../../../../Services';
import { GetParams, showError } from '../../../../../Helper';
import AssignedToAutocomplete from './components/AssignedToAutocomplete';
import { headerData } from './headerData';
import { isEqual } from 'lodash';
import { TableActions } from '../../../../../Enums';

const ActivityTracking = ({ parentTranslationPath }) => {
  const { t } = useTranslation(parentTranslationPath);
  const [data, setData] = useState({ result: [], totalCount: 0 });
  const [isLoading, setIsLoading] = useState(false);
  const [activeItem, setActiveItem] = useState(null);
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 25,
  });
  const [managementDialogOpen, setManagementDialogOpen] = useState(false);

  const getVendorActivities = useCallback(async () => {
    try {
      setIsLoading(true);
      const res = await GetVendorActivities(+GetParams('id'), filter);
      setData(res);
    } catch (error) {
      showError(t('something_went_wrong'));
    } finally {
      setIsLoading(false);
    }
  }, [filter]);

  const onFilterValuesChanged = (filterValue) => {
    if (filterValue && !!Object.values(filterValue).length) {
      const { value, searchableKey } = Object.values(filterValue)[0];
      setFilter((filter) => ({
        ...filter,
        [searchableKey]: value,
      }));
    } else {
      const updatedFilter = Object.fromEntries(
        Object.entries(filter).filter(([_key, value]) => !!value || value === 0)
      );
      if (!isEqual(updatedFilter, filter)) {
        setFilter(updatedFilter);
      }
    }
  };

  useEffect(() => {
    getVendorActivities();
  }, [getVendorActivities]);
  return (
    <div className='p-3 flex d-flex-column gap-1'>
      <div>
        <ButtonBase
          className='btns theme-solid px-3'
          onClick={() => setManagementDialogOpen(true)}
        >
          <span className='mdi mdi-plus' />
          {t(`add_activity`)}
        </ButtonBase>
      </div>
      <div className='flex fj-center'>
        <AssignedToAutocomplete
          parentTranslationPath={parentTranslationPath}
          onSelect={(value) =>
            setFilter((filter) => ({ ...filter, assignedToId: value?.id }))
          }
        />
      </div>
      <Tables
        data={data.result}
        headerData={headerData}
        totalItems={data.totalCount}
        parentTranslationPath={parentTranslationPath}
        isLoading={isLoading}
        onPageIndexChanged={(pageIndex) =>
          setFilter({ ...filter, pageIndex: pageIndex + 1 })
        }
        isWithFilter
        filterData={headerData}
        itemsPerPage={filter.pageSize}
        activePage={filter.pageIndex}
        onPageSizeChanged={(pageSize) => setFilter({ ...filter, pageSize })}
        onFilterValuesChanged={onFilterValuesChanged}
        FilterDisabledButton
        defaultActions={[]}
        actionsOptions={{
          onActionClicked: (actionEnum, item) => {
            setActiveItem(item);
            if (actionEnum === TableActions.edit.key) {
              setManagementDialogOpen(true);
            }
          },
        }}
      />
      {managementDialogOpen && (
        <VendorActivityManagementDialog
          open
          onClose={() => setManagementDialogOpen(false)}
          parentTranslationPath={parentTranslationPath}
          activeItemId={activeItem?.activityId}
          reload={getVendorActivities}
        />
      )}
    </div>
  );
};
export default ActivityTracking;
